import SocialRoutes from './SocialRoutes';

export default SocialRoutes;
